/**
 * The Price Seeker site catalogue, for Rate Cards.
 *
 * A face's site is `site_id`, the Price Seeker master site id (decision A6,
 * 2026-09-19): the site of a face is the channel the rate shop compares on,
 * a Price Seeker concept, so it is picked from Price Seeker's own list and
 * stored as its id. The old free-text `site_code` and the hardcoded mock
 * list (which included `own_web`, with no Price Seeker counterpart) are gone.
 *
 * Fetched once per mount from the same endpoint the shared
 * `AppSitesAutocomplete` uses, so the picker and the table labels agree.
 */
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { BACKEND_APIS } from '@constants'

const SiteCatalog = createContext({ options: [], loading: true, labelOf: (id) => String(id) })

export function SiteCatalogProvider({ children }) {
	const [state, setState] = useState({ options: [], loading: true })
	useEffect(() => {
		let alive = true
		fetch(`${BACKEND_APIS.MASTER_DATA}/options/site`, { credentials: 'include' })
			.then(r => (r.ok ? r.json() : []))
			.then(rows => alive && setState({
				options: (Array.isArray(rows) ? rows : []).map(o => ({ id: Number(o.value), name: o.label, market: o.market })),
				loading: false }))
			.catch(() => alive && setState({ options: [], loading: false }))
		return () => { alive = false }
	}, [])
	const value = useMemo(() => {
		const byId = new Map(state.options.map(o => [o.id, o.name]))
		return { ...state, labelOf: (id) => byId.get(Number(id)) || (id == null ? '—' : `site #${id}`) }
	}, [state])
	return <SiteCatalog.Provider value={value}>{children}</SiteCatalog.Provider>
}

export function useSiteCatalog() {
	return useContext(SiteCatalog)
}
